import React from 'react'
import { useParams } from 'react-router-dom'
import LayoutMain from '../../layouts/LayoutMain'
import MyBlock from '../../UI/block/MyBlock'
import SubmenuSuppliers from '../submenu/SubmenuSuppliers'
import MyBlockHeader from '../../UI/block/MyBlockHeader'
import SupplierView from './view/SupplierView'

const Supplier = () => {

    const { supplierId } = useParams()

  return (
    <LayoutMain>
		<MyBlock>
			<SubmenuSuppliers />
		</MyBlock>
		{/* <MyBlock>
			<h2>Партії товарів (QR-коди) з замовлення KeyCRM</h2>
		</MyBlock> */}
		<MyBlockHeader
            header={'Постачальник № ' + supplierId}
            isBack={true}
            // options={
            //     <SupplyOrderOptions />
            // }
        />
		<MyBlock>
			<SupplierView 
				supplierId={supplierId}
			/>
		</MyBlock>
    </LayoutMain>
  )
}

export default Supplier